<template>
    <div class="page">
        <div class="main_body">

            <div class="top_label">
                <span class="lable_name">
                    {{ plan_name }}
                </span>
                <span style="color:#409EFF;" class="el-icon-arrow-left" @click="$router.goBack(-1)">返回</span>
            </div>

            <div class="self_top_statistics_box">
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">做题数</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.total_count}}</span>
                            <span class="unit">题</span>
                        </div>
                        
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span><i class="el-icon-edit"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">平均正确率</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.avg_score}}</span>
                            <span class="unit">%</span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span style="background:#FDE2E2;color:#F56C6C"><i class="el-icon-s-data"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">阅读题量</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.read_count}}</span>
                            <span class="unit">题</span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span><i class="el-icon-edit"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">阅读平均正确率</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.read_avg_score}}</span>
                            <span class="unit">%</span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span style="background:#FDE2E2;color:#F56C6C"><i class="el-icon-s-data"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">应试题量</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.specialty_count}}</span>
                            <span class="unit">题</span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span><i class="el-icon-edit"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">应试平均正确率</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.specialty_avg_score}}</span>
                            <span class="unit">%</span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span style="background:#FDE2E2;color:#F56C6C"><i class="el-icon-s-data"></i></span>
                    </div>
                </div>
                <div class="self_top_statistics_box_item">
                    <div class="self_top_statistics_box_item_left">
                        <span class="title">学习总时长</span>
                        <div class="number_box">
                            <span class="number">{{self_top_data.total_time}}</span>
                            <span class="unit"></span>
                        </div>
                    </div>
                    <div class="self_top_statistics_box_item_right">
                        <span style="background:#E1F3D8;color:#67C23A"><i class="el-icon-alarm-clock"></i></span>
                    </div>
                </div>
            </div>

            <div class="self_top_statistics_chartbox">
                <div class="self_top_statistics_charttitle">
                    本月学习统计
                </div>
                <Selfchartdetail :plan_id="form.plan_id"></Selfchartdetail>
            </div>

            <el-table
                :data="self_data"
                tooltip-effect="dark"
                style="width: 100%;display: inline-block;margin-top: 30px;"
                >
                <el-table-column
                type="index"
                width="55">
                </el-table-column>
                <el-table-column
                prop="name"
                label="姓名"
                >
                </el-table-column>
                <el-table-column
                prop="stuid"
                label="学号"
                >
                </el-table-column>
                <el-table-column
                prop="read_number"
                label="阅读在线"
                >
                </el-table-column>
                <el-table-column
                prop="read_rate"
                label="正确率"
                >
                
                </el-table-column>
                <el-table-column
                prop="specialty_number"
                label="应试英语"
                >
                </el-table-column>
                <el-table-column
                prop="specialty_rate"
                label="正确率"
                >
                </el-table-column>
                <el-table-column
                prop="study_time"
                label="做题时长"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import totalscore from "../../../untils/totalscoretemplate.vue";
import periodicstatistics from "../../../untils/periodicstatisticstemp.vue";
import temporarystatistics from "../../../untils/temporarystatistics.vue";
import Selfchartdetail from "../../../untils/chart/selfchartdetail.vue";

import Http from "../../apis/statistics";
import Work from "../../apis/work";
export default {
    components:{
        'Total-score':totalscore,
        'Periodic-statistics':periodicstatistics,
        'Temporary-statistics':temporarystatistics,
        Selfchartdetail
    },
    data() {
        return {
            self_top_data:[],



            activeName: 'first',
            form:{
                plan_id:'',
                type:0,
                page:1,
                pageSize:20
            },
            loading:false,
            student:[],
            list:[],
            temporarylist:[],
            self_form:{
                plan_id:'',
                name:''
            },
            plan_name:'',
            self_data:[],
            checkList:['name','stuid','low_rate','high_rate','average_rate'],
            file_form:{'name':'姓名','stuid':'学号','low_rate':'最低正确率','high_rate':'最高正确率','average_rate':'平均正确率','read_number':'阅读做题数','read_rate':'阅读正确率','specialty_number':'应试做题数','specialty_rate':'应试正确率','time':'耗时','detail':'做题材料'},
            workfile_form:{'name':'姓名','stuid':'学号','low_rate':'最低正确率','high_rate':'最高正确率','average_rate':'平均正确率','score':'得分','read_number':'阅读做题数','read_rate':'阅读正确率','specialty_number':'应试做题数','specialty_rate':'应试正确率','time':'耗时','detail':'做题材料'}
        };
    },

    created(){
        this.form.plan_id = this.$route.query.plan_id
        this.form.state = this.$route.query.state
        this.self_form.plan_id = this.$route.query.plan_id
        this.plan_name = this.$route.query.plan_name
        //this.getDetail(this.form.plan_id,this.form.state)
        //this.getBottomStudent()
        this.geList()
        this.geTemporaryList()
        this.selfStudy()
        setTimeout(()=>{
            //this.setData()
        },300)


        // 自主学习
        this.getSelfStudyDetailTop()
    },

    methods: {

        // 自主学习 - 顶部统计
        getSelfStudyDetailTop(){

            Http.selfStudyDetailTop({plan_id:this.form.plan_id}).then((res) => {
                this.self_top_data = res.data
            });

        },
  



        // 周期作业
        geList(){

            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            Work.getWork(this.form).then((res) => {
                loading.close()
                this.list = res.data
            });

        },
        // 临时作业
        geTemporaryList(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.form.type = 1
            Work.getWork(this.form).then((res) => {
                loading.close()
                this.temporarylist = res.data
            });

        },
        setData(){
            this.$refs.totalscore.setData(this.file_form,this.checkList)
            this.$refs.periodicstatistics.setData(this.workfile_form,this.checkList,this.form.state)
            this.$refs.temporarystatistics.setData(this.file_form,this.checkList,this.form.state)
        },

        // 总成绩统?
        getDetail(plan_id,state){
            this.$refs.totalscore.getDetail(plan_id,state)
        },

        // 下方学生列表
        getBottomStudent(){
            this.$refs.totalscore.getBottomStudent(this.file_form,this.checkList)
            
        },

        viewWorkDetail_(task_id){
            this.loading = true
            this.$refs.periodicstatistics.viewWorkDetail(this.form.plan_id,task_id)
        },
        // 临时作业下方学生列表
        viewWorkTemporaryDetail_(task_id){
            this.loading = true
            this.$refs.temporarystatistics.viewWorkDetail(this.form.plan_id,task_id)
        },

        // 自主学习
        selfStudy(){

            Http.selfStudy({plan_id:this.form.plan_id}).then((res) => {
                this.self_data = res.data
            });
        },

        selectStudent(){
            this.selfStudy()
        },
        //
        handleClick(tab, event) {
            
            this.activeName = tab.name
            if(tab.index == 0){
                this.getDetail(this.form.plan_id)
                this.getBottomStudent()
            }else if(tab.index == 1){
                this.form.type = 0
                this.geList()
            } else if(tab.index == 2){
                this.form.type = 1
                this.geTemporaryList()
            } else{
                this.selfStudy()
            }
        },
        hideLoading(res){
            this.loading = res
        }
        
    }
  };
</script>
<style scoped>
.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}

.lable_name{
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.el-icon-arrow-left{
    cursor: pointer;
}
.self_top_statistics_box{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
    margin-top: 20px;
}
.self_top_statistics_box_item{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.self_top_statistics_box_item_left{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 15px;
}
.self_top_statistics_box_item_left .title{
    font-size: 14px;
    font-weight: 700;
    color: #000000;
}
.self_top_statistics_box_item_left .number{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}
.self_top_statistics_box_item_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
}

.self_top_statistics_box_item_right span{
    background: #D9ECFF;
    color: #409eff;
    padding: 10px;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
}
.number_box{
    display: flex;
    justify-content: flex-start;
    
    align-items: flex-end;
    gap: 5px;
}
.number_box .unit{
    font-size: 12px;
    color: #000000;
}
.self_top_statistics_chartbox{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    box-sizing: border-box;
    margin-top: 20px;
}
.self_top_statistics_charttitle{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
}






@media screen and (min-width:320px) and (max-width:1199px) {

}
@media (min-width: 1200px) and (max-width: 1920px) {
    .label_button_box_right >>> .el-button{
        float: right;
        margin-top: 0px;
    }
    .label_button_box_left{
        float: right;
        width:21vw;
    }
}
@media (min-width: 1921px) and (max-width: 2600px) {
    .label_button_box_right >>> .el-button{
        float: right;
    }
    .label_button_box_left{
        float: right;
        width:19vw;
    }
}
.main_body >>> .el-tabs{
    margin-top: 1vw;
}

.left_worrk{
    text-align: center;
    width: 40vw;
    position: relative;
}
.left_worrk p{
    display: inline-block;
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: left;
    line-height: 26px;
    font-size: 14px;
}
.left_worrk .number{
    float: left;
    width: 25px;
    height: 25px;
    background: #409eff;
    border-radius: 50px;
    text-align: center;
    line-height: 25px;
    color: #ffffff;
    margin-right: 10px;
}
.left_worrk .title{
    float: left;
    line-height: 25px;
    font-weight: 700;
}
.right_work{

    position: absolute;
    width: 10vw;
    padding: 10px;
    right: 0;
    top: 50%;
    bottom: 50%;
    margin-top: -25px;
}
.label_button_box{
    width: 100%;
    height: 2vw;
    line-height: 2vw;
    display: inline-block;
    margin-bottom: 20px;
    margin-top:20px;
}
.label_button_box_left{
    float: left;
}
.label_button_box_right{
    float: right;

}
.label_button_box_right >>> .el-button{
        float: right;
    }
.label_button_box_left >>> .el-input{
    float: left;
    width: 15vw;
    margin-right: 10px;
}
.second_box >>> .el-row{
    margin-bottom: 15px;
}
</style>